<template>
	<div id="app">
		<router-view v-if="isReload" />
	</div>
</template>

<script>
	export default {
		name: "App",
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isReload: true
			}
		},
		methods: {
			reload() {
				this.isReload = false
				this.$nextTick(() => {
					this.isReload = true
				})
			}
		}
	};
</script>

<style>
	/* 全局公共样式 */
	@import url("./assets/css/normalize.css");
	@import url("./assets/css/base.css");
	@import url("./assets/icon/iconfont.css");

	* {
		padding: 0;
		margin: 0;
	}

	body,
	html {
		width: 100%;
		height: 100%;
		min-width: 1200px;
		min-height: 500px;
	}

	/* body{
  padding-right: 0px !important;
  overflow: hidden;
} */

	/* input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
} */

	/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c2c2c;
  width: 100%;
  height: 100%;
} */

	#app {
		width: 100%;
		height: 100%;
		background-color: #f4f8f9;
	}

	/* 定义可变必填项的*号标识 */
	.el-form-required-true .el-form-item__label::before {
		content: "*";
		color: #f56c6c;
		margin-right: 4px;
	}

	.pub_dialog {
		position: absolute;
		top: 50%;
		left: 50%;
		margin: 0 !important;
		transform: translate(-50%, -50%);
		max-height: calc(100% - 30px);
		max-width: calc(100% - 30px);
		display: flex;
		flex-direction: column;
	}

	.pub_dialog .el-dialog__body {
		overflow: auto;
	}
</style>
